import { theme } from "antd";
import "../config/globals.css";

export const RandomBackgroundsComponent = ({ children }) => {
  const {
    token: { colorBgLayout },
  } = theme.useToken();

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        backgroundColor: colorBgLayout,
      }}
    >
      {/* Imagen de fondo 1 */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />
      {/* Imagen de fondo 2 */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: "50%",
          width: "100%",
          height: "100%",
        }}
      />
      {/* Contenido principal de la app */}
      <div style={{ position: "relative", zIndex: 1 }}>{children}</div>
    </div>
  );
};
